export const UpdateContactByPocid = `
    mutation updateContactByPocid ($pocid: BigInt!, $contactPatch: ContactPatch!) {
        updateContactByPocid (input: {
            pocid: $pocid,
            contactPatch: $contactPatch
        }) {
            contact {
                pocid
                name
                cell
                land
                email
                pubconinfo
                instruc
                datelastchanged
                document
            }
        }
    }
`;
